module.exports = __webpack_public_path__ + "img/tab_customer.bab157b7.svg";